// tslib 2.x's __exportStar uses Object.defineProperty with non-configurable getters,
// so `export * from 'formik'` produces properties that sinon cannot stub. Mutable `let`
// re-exports keep the properties writable so tests can replace them.
import {
  Field as _Field,
  FieldArray as _FieldArray,
  Formik as _Formik,
  useFormikContext as _useFormikContext,
} from 'formik';

export let useFormikContext = _useFormikContext;
export let Formik = _Formik;
export let Field = _Field;
export let FieldArray = _FieldArray;

export type { FormikContextType, FormikErrors, FormikHelpers, FieldArrayRenderProps, FieldProps } from 'formik';
